import { TeamDecisionState } from '@/redux/types/teamDecision'

export const initialTeamDecisionState: TeamDecisionState = {
  proposals: [],
  voteCounts: {},
  myVoteProposalId: null,
  votingClosed: false,
  winningStrategyText: null,
  winningProposalId: null,
}
